import { Component, OnInit, ViewChild } from '@angular/core';

import { AppInformationService, ArkUnitOfWork, AuthService, SessionInformationService, UtilityService } from 'app/core/core.module';
import { DxDataGridComponent, DevExtremeModule } from 'devextreme-angular';
import { alert } from 'devextreme/ui/dialog';
import { environment } from 'environments/environment';
import _ from 'lodash';

@Component({
    selector: 'app-member-info',
    templateUrl: './member-info.component.html',
    styleUrls: ['./member-info.component.scss'],
    imports: [DevExtremeModule],
    standalone: true,
})
export class MemberInfoComponent implements OnInit {
    people: any[];
    memberCode: any;
    memberEmail: any;
    family: any;
    familyInfo: any;
    states: any;
    serviceName = environment.serviceName;
    noInfo = false;
    uploadHeaders: any;
    photoUrl: string;
    households: any;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(
        private appInfo: AppInformationService,
        private uow: ArkUnitOfWork,
        private utility: UtilityService,
        private sessionInfo: SessionInformationService,
        private auth: AuthService
    ) {}

    async ngOnInit() {
        this.uploadHeaders = { Authorization: 'Bearer ' + this.auth.currentUser.jwtToken };
        if (this.auth.currentUser && this.auth.currentUser.personId) {
            // const person = await this.uow.people.byId(this.auth.currentUser.personId);
            const person = await this.uow.getPersonById(this.auth.currentUser.personId);
            // console.log(person);
            this.memberCode = person.code;
            this.memberEmail = person.email;
            this.sessionInfo.setItem('memberCode', this.memberCode);
            this.sessionInfo.setItem('memberEmail', this.memberEmail);
        }
        this.households = await this.uow.getHouseholds();
        this.states = await this.utility.getStates();
        this.memberCode = this.sessionInfo.getItem('memberCode');
        this.memberEmail = this.sessionInfo.getItem('memberEmail');
        if (this.memberCode) {
            await this.getData();
        } else this.noInfo = true;
    }

    async getData() {
        try {
            this.family = await this.utility.getFamilyInfosByMemberCode(this.memberCode);
            this.familyInfo = this.family.familyInfo[0];
            if (this.family.familyInfo.length === 0) this.noInfo = true;
            const household = _(this.households).find((h) => h.id === this.familyInfo.HouseholdId);
            this.familyInfo.household = household ? household.name : '';
            await this.getPhotos();
        } catch (error) {
            this.noInfo = true;
        }
    }

    private async getPhotos() {
        const photos = await this.uow.getFamilyPhotos(this.familyInfo.Id);
        const familyPhotos = photos.map((photo: any) => {
            return { photo, url: this.utility.getPhoto(photo.fileName) };
        });
        const photo: any = _(familyPhotos).find((p) => p.photo.isDirectoryPhoto);
        if (photo) this.photoUrl = photo.url;
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            }
        );
    }

    async printMemberInfo() {
        await this.utility.printMemberInfoSheet(this.memberCode);
    }
    async photoUploaded() {
        const result = await alert(`Your photo has been uploaded and is pending approval from the church office.`, `${this.appInfo.systemName}`);
        await this.utility.emailPhotoUploaded(this.memberEmail, `Photo Uploaded from ${this.memberEmail}`);
        return;
    }
}
